import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom'
import { Login, NotFound } from '@pages'
import { MenuItems } from './config/menu'

import { MenuTemplate } from './templates/MenuTemplate'
import { useAtom } from 'jotai'
import { themeType, authState } from '@state'
import { ErrorBoundary } from './components/ErrorBoundary'
import './index.css'
import { ToastContainer } from 'react-toastify'
import { theme, useTheme } from '@ss/meta-core-components'
import { IColor } from '@ss/meta-core-components/lib/theme'
import { config } from './config'

/**
 * Componente app <br/>
 *  - contiene i path delle pagine<br/>
 *  - contiene il template base dell app<br/>
 *  - contiene le personalizzazzioni del tema<br/>
 *  - contiene le var css
 * @component
 */
const App: React.FC = () => {
  const navigate = useNavigate()
  //region get data from storage
  const [auth] = useAtom(authState)
  const [_themeType] = useAtom(themeType)
  //endregion

  const { pathname } = useLocation()

  const { style, mergeTheme } = useTheme()

  //starting app (personalizzazzioni tema)
  useEffect(() => {
    console.log('Metamorphosis started...')
    theme.type = _themeType
    mergeTheme('light', {
      color: { text: 'grey' },
      style: {},
      components: {},
    })
  }, [])

  //effect che controlla presenza e validita' del token nel local/session storage
  useEffect(() => {
    if (auth.token) {
      if (pathname === '/') navigate(config.landingPage)
      else navigate(pathname)
    } else {
      navigate('/login')
    }
  }, [auth.token])

  return (
    <Container
      className='App'
      colors={style.color}
      style={{
        ...style.style,
      }}
    >
      <ErrorBoundary>
        <Routes>
          <Route path={'/login'} element={<Login />} />
          <Route
            path={'/*'}
            element={
              <MenuTemplate>
                <Routes>
                  {MenuItems.map(({ path, element }, index) => (
                    <Route key={index} path={path} element={element} />
                  ))}
                  <Route key={'not-found'} path={'/*'} element={<NotFound />} />
                </Routes>
              </MenuTemplate>
            }
          />
        </Routes>
      </ErrorBoundary>

      {/* Container per le toast notification */}
      <ToastContainer
        data-cy={'toast'}
        position='top-right'
        autoClose={5000}
        theme='colored'
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Container>
  )
}

export default App

//region STYLE
const Container = styled.div<{ colors: IColor }>`
  box-sizing: border-box;

  --primary: ${({ colors: { primary } }) => primary};
  --secondary: ${({ colors: { secondary } }) => secondary};
  --focus: ${({ colors: { focus } }) => focus};
  --text: ${({ colors: { text } }) => text};
  --secondaryText: ${({ colors: { secondaryText } }) => secondaryText};
  --disabledText: ${({ colors: { disabledText } }) => disabledText};
  --disabledFilter: ${({ colors: { disabledFilter } }) => disabledFilter};
  --shadow: ${({ colors: { shadow } }) => shadow};
  --error: ${({ colors: { error } }) => error};
  --background: ${({ colors: { backGround } }) => backGround};
  --card-background: ${({ colors: { cardBackground } }) => cardBackground};

  font-family: 'Lato', sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  * {
    box-sizing: border-box;
  }

  background: var(--background);
  color: var(--text);

  width: 100%;
  min-width: 100vw;
  height: 100%;
  min-height: 100vh;
`
//endregion
